module.exports = __webpack_public_path__ + "img/mobile-app-development.ca664148.png";